<template>
  <a-menu :class="'default-nav'" theme="dark" mode="horizontal">
    <a-menu-item :class="'default-nav__item'" @click="toggleSider">
      <a-icon
        :class="'default-nav__icon'"
        theme="outlined"
        :type="siderCollapsed ? 'menu' : 'menu-fold'"
      />
    </a-menu-item>
    <a-menu-item
      v-for="(item, index) in items"
      :class="'default-nav__item'"
      :disabled="$route.path === item.href"
      :key="index"
      :title="item.icon"
      @click="goTo(item)"
    >
      <a-icon :class="'default-nav__icon'" theme="outlined" :type="item.icon" />
    </a-menu-item>
  </a-menu>
</template>

<script>
export default {
  props: ['siderCollapsed'],
  data() {
    return {
      items: [
        {
          icon: 'home',
          href: '/',
          isExternal: false,
        },
        {
          icon: 'github',
          href: 'https://github.com/devlegacy',
          isExternal: true,
        },
        {
          icon: 'gitlab',
          href: 'https://gitlab.com/devlegacy',
          isExternal: true,
        },
        {
          icon: 'info-circle',
          href: '/about',
          isExternal: false,
        },
      ],
    };
  },
  methods: {
    goTo(item) {
      if (item.isExternal) {
        window.open(item.href, '_blank');
      } else {
        // console.log(this.$route.name);
        // console.log(this.$route.path);
        this.$router.push(item.href);
      }
      // console.log(this.$route.path.match());
      // console.log(this.$route.path.match());
    },
    toggleSider() {
      this.$emit('on-toggle-sider', !this.siderCollapsed);
    },
  },
};
</script>

<style lang="scss" scoped>
.default {
  &-nav {
    display: flex;

    background: transparent;

    &__item {
      display: flex;
      min-width: 50px;
      height: 34px;
      padding: 0 2px;
      border-radius: 4px;

      color: #fff;

      align-items: center;
      justify-content: center;

      &.ant-menu-item {
        &-selected {
          background: transparent;
        }
        &-disabled {
          color: #fff !important;

          cursor: pointer;
          opacity: 1;
        }
      }

      &:hover {
        background: rgba(255, 255, 255, 0.5);
      }

      // &:focus,
      // &:active {
      //   background: transparent;
      // }

      // &:nth-child(1n + 3) {
      //   display: none;
      //   @media screen and (min-width: 576px) {
      //     display: flex;
      //   }
      // }
    }

    &__icon {
      margin: 0;

      font-size: 20px;

      @media screen and (min-width: 768px) {
        font-size: 18px;
      }
    }
  }
}
</style>
